export const languageColors: Record<string, string> = {
  JavaScript: "#f1e05a",
  TypeScript: "#3178c6",
  Python: "#3572A5",
  Java: "#b07219",
  "C++": "#f34b7d",
  C: "#555555",
  "C#": "#239120",
  PHP: "#4F5D95",
  Ruby: "#701516",
  Go: "#00ADD8",
  Rust: "#dea584",
  Swift: "#ffac45",
  Kotlin: "#A97BFF",
  Dart: "#00B4AB",
  HTML: "#e34c26",
  CSS: "#1572B6",
  SCSS: "#c6538c",
  Shell: "#89e051",
  PowerShell: "#012456",
  Dockerfile: "#384d54",
  YAML: "#cb171e",
  JSON: "#292929",
  Markdown: "#083fa1",
  Vue: "#4FC08D",
  React: "#61DAFB",
  Svelte: "#ff3e00",
  Angular: "#DD0031",
  Jupyter: "#DA5B0B",
  R: "#198CE7",
  MATLAB: "#e16737",
  Lua: "#000080",
  Perl: "#0298c3",
  Scala: "#c22d40",
  Clojure: "#db5855",
  Haskell: "#5e5086",
  Elixir: "#6e4a7e",
  Erlang: "#B83998",
  F: "#b845fc",
  Julia: "#a270ba",
  Nim: "#ffc200",
  Crystal: "#000100",
  Zig: "#ec915c",
  Assembly: "#6E4C13",
  Objective: "#438eff",
  Vim: "#199f4b",
  Emacs: "#c065db",
};

export const getLanguageColor = (language: string): string => {
  return languageColors[language] || "#6b7280";
};
